import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ViguideRecommendationsStore } from '@store';
import { filter, take, takeUntil } from 'rxjs/operators';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { BannerComponent } from '../../../../shared/components/banner/banner.component';
import { OptimizationBannerService } from './optimization-banner.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-optimization-banner',
  standalone: true,
  imports: [CommonStandaloneModule, BannerComponent],
  templateUrl: './optimization-banner.component.html',
  styleUrls: ['./optimization-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimizationBannerComponent implements OnInit, OnDestroy {
  @Input() fetchDashboardProInstallations: boolean;
  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    public viguideRecommendationsStore: ViguideRecommendationsStore,
    public optimizationBannerService: OptimizationBannerService
  ) {}

  ngOnInit(): void {
    this.viguideRecommendationsStore.shouldFetchOptimizationRecommendations$
      .pipe(
        filter((value) => !!value),
        take(1),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(() => {
        this.viguideRecommendationsStore.fetchBoilerOptimizationsRecommendations();
        if (this.fetchDashboardProInstallations) {
          this.viguideRecommendationsStore.fetchProInstallations();
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
